import React, { useEffect, useState } from "react";
import { Offcanvas, Button, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Calendar } from "lucide-react";
import CommonDropdown from "../../common/common_dropDown";
import {
  getVehicleDetailAPI,
  submitAPI,
  UpdateAPI,
  getFuelHistoryAPI,
  addAttachmentApi,
} from "./FuelHistoryApi";
import DOMPurify from "dompurify";
import ErrorExtractor from "../../common/error_extractor";
import { FileUploader } from "../../common/FileUploader";
import CommonStaticDropdown from "../../common/common_static_dropdown";
import { tr } from "date-fns/locale";

const FuelFistoryForm = ({ id, show, handleClose }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const [selectedAssignTo, setSelectedAssignTo] = useState(null);
  const [selectedLicensePlate, setSelectedLicensePlate] = useState(null);
  const [vehicleName, setVehicleName] = useState("");
  const [image, setImage] = useState("");
  const [imageRemoved, setImageRemoved] = useState(false);
  const [imageEdit, setImageEdit] = useState("");
  const [vinValue, setVinValue] = useState("");
  const [lastKmRecord, setLastKmRecord] = useState("0");
  const [currentKm, setCurrentKm] = useState("");
  const [fuelQty, setFuelQty] = useState("");
  const [fuelPrice, setFuelPrice] = useState("");
  const [totalPrice, setTotalPrice] = useState("");

  const [isLoader, setIsLoader] = useState(false);

  const fuelTypeList = [
    { label: "Petrol", value: "Petrol" },
    { label: "Diesel", value: "Diesel" },
    { label: "Gas", value: "Gas" },
    { label: "Electric", value: "Electric" },
  ];

  const [selectedFuelType, setSelectedFuelType] = useState(null);

  const handleSelectFuelType = (item) => {
    console.log("Selected:", item);
    setSelectedFuelType(item); // store selected id
  };

  useEffect(() => {
    console.log("ss->", id);
    if (id != null) {
      getKmHistDetails();
    }
  }, [id]);
  useEffect(() => {
    const qty = parseFloat(fuelQty) || 0;
    const price = parseFloat(fuelPrice) || 0;
    setTotalPrice((qty * price).toFixed(2)); // format to 2 decimal places
  }, [fuelQty, fuelPrice]);

  const handleFuelQtyChange = (e) => {
    setFuelQty(e.target.value);
  };

  const handleFuelPriceChange = (e) => {
    setFuelPrice(e.target.value);
  };
  const handleCurrentKmChange = (e) => {
    const value = e.target.value;
    setCurrentKm(value);

    const last = parseFloat(lastKmRecord) || 0;
    const current = parseFloat(value) || 0;

    if (current < last) {
      setErrorMsg((prev) => ({
        ...prev,
        km: "Current KM cannot be less than last recorded KM",
      }));
    } else {
      setErrorMsg((prev) => ({ ...prev, km: "" }));
    }
  };
  const [errorMsg, setErrorMsg] = useState({
    vehicle_id: "",
    fuel_type: "",
    km: "",
    qty: "",
    price: "",
  });
  const handleSelectVin = (item) => {
    console.log("Selected:", item);
    setSelectedLicensePlate(item); // store selected id
  };
  const handleSelectAssign = (item) => {
    console.log("Selected:", item);
    setSelectedAssignTo(item); // store selected id
  };
  useEffect(() => {}, []);
  useEffect(() => {
    getVehicleDetails();
  }, [selectedLicensePlate]); //
  const getVehicleDetails = async () => {
    try {
      if (!selectedLicensePlate?.value) return; // safety check

      const response = await getVehicleDetailAPI(selectedLicensePlate.value);

      console.log("vehicle details", response);
      if (response.data?.success) {
        const vehicleData = response.data.vehicle;
        setVehicleName(vehicleData.name);
        setVinValue(vehicleData.vin);

        setLastKmRecord(vehicleData.kilometer_driven);
      } else {
        console.error(
          "Failed to fetch vehicle details:",
          response.data?.message
        );
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };
  const getKmHistDetails = async () => {
    try {
      const response = await getFuelHistoryAPI(id);

      console.log("vehicle details", response);
      if (response.data?.success) {
        const vehicleData = response.data.history;
        setVehicleName(vehicleData.name);
        setVinValue(vehicleData.vin);
        setLastKmRecord(vehicleData.last_km);
        setCurrentKm(vehicleData.current_km);
        setFuelQty(vehicleData.qty);
        setFuelPrice(vehicleData.price);
        setTotalPrice(vehicleData.total_price);
        setSelectedLicensePlate({
          value: vehicleData.vehicle_id,
          label: vehicleData.lic_no,
        });
        setSelectedFuelType({
          value: vehicleData.fuel_type,
          label: vehicleData.fuel_type,
        });
        console.log("hjfuesgfuew", {
          value: vehicleData.fuel_type,
          label: vehicleData.fuel_type,
        });

        setImageEdit(vehicleData.image);
      } else {
        console.error(
          "Failed to fetch vehicle details:",
          response.data?.message
        );
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };
  const handleFileSelect = (files) => {
    console.log("Selected files:", files);

    if (files && files.length > 0) {
      setImage(files[0]); // Set the first file's base64 string
    }
  };
  const removeEditImage = () => {
    setImageRemoved(true);
    setImageEdit(null); // Clear the edit image
  };
  const resetForm = () => {
    setSelectedLicensePlate(null);
    setSelectedAssignTo(null);
    setVehicleName("");
    setVinValue("");
    setCurrentKm("");
    setFuelQty("");
    setFuelPrice("");
    setLastKmRecord("");
    setImage("");
    setImageEdit("");

    setErrorMsg({
      vehicle_id: "",
      fuel_type: "",
      km: "",
      qty: "",
      price: "",
    });
  };
  const attachSubmitImage = async (id) => {
    const bodyData = {
      attachment: image,
    };
    try {
      let response = await addAttachmentApi(id, bodyData);
      console.log("Attachment response", response);
    } catch (err) {
      console.error("Error attaching image:", err);
    }
  };
  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();
    try {
      const preSanitizeData = {
        vehicle_id: selectedLicensePlate?.value ?? "",
        fuel_type: selectedFuelType?.value ?? "",
        km: currentKm,
        qty: fuelQty,
        price: fuelPrice,
        image_removed: imageRemoved,
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (
          typeof value === "boolean" ||
          typeof value === "number" ||
          Array.isArray(value)
        ) {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      let response;
      if (id == null) {
        response = await submitAPI(sanitizedData);
      } else {
        response = await UpdateAPI(sanitizedData, id);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {};
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        handleClose(response);
        if (image) {
          attachSubmitImage(id ?? response.data.id);
        }
        resetForm();
      }

      return response.data;
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (
        err.response &&
        err.response.status === 400 &&
        err.response.data.error
      ) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
    } finally {
      setIsLoader(false);
    }
  };
  const handleCloseWithReset = () => {
    resetForm(); // Reset form state
    handleClose(); // Close the Offcanvas
  };

  const fuelLabels = {
    Gas: {
      qty: "Gas Quantity (kg/m³)",
      price: "Gas Price (per kg/m³)",
    },
    Electric: {
      qty: "Battery Charge (kWh)",
      price: "Electricity Price (per kWh)",
    },
    Petrol: {
      qty: "Petrol Quantity (litres)",
      price: "Petrol Price (per litre)",
    },
    Diesel: {
      qty: "Diesel Quantity (litres)",
      price: "Diesel Price (per litre)",
    },
  };

  // Fallback if no match
  const fuelQtyLabel =
    fuelLabels[selectedFuelType?.value]?.qty || "Fuel Quantity";
  const fuelPriceLabel =
    fuelLabels[selectedFuelType?.value]?.price || "Fuel Price";

  return (
    <Offcanvas show={show} onHide={handleCloseWithReset} placement="end">
      <Offcanvas.Header
        closeButton={false}
        className="d-flex justify-content-between align-items-center"
      >
        <Offcanvas.Title>
          {id !== null ? "Edit" : "New"} Fuel history
        </Offcanvas.Title>
        <button
          onClick={handleCloseWithReset}
          style={{
            backgroundColor: "transparent",
            border: "2px solid #D4DDE7",
            color: "#172B4D",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          X
        </button>
      </Offcanvas.Header>
      <hr />
      <Offcanvas.Body>
        <div className="row">
          <div className="col-xl-12 ">
            <label htmlFor="vin" className="form-label fw-400 d-flex">
              License Plate <span className="error-text">*</span>
            </label>
            <CommonDropdown
              apiUrl={`${apiUrl}get_vehicle`}
              placeholder="Select license  plate"
              value={selectedLicensePlate}
              onSelect={handleSelectVin}
            />{" "}
            <span className="error-text">{errorMsg.vehicle_id}</span>
          </div>
          <div className="col-xl-6 mt-2">
            <label htmlFor="fill" className="form-label  fw-400">
              Vehicle name
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="fill"
              placeholder="vehicle name"
              value={vehicleName}
              readOnly
              style={{
                backgroundColor: "#F8F8F8",
                border: "0.8px solid #E5E5E5",
                pointerEvents: "none", // optional: prevents editing
              }}
            />
          </div>
          <div className="col-xl-6 mt-2">
            <label htmlFor="plate" className="form-label  fw-400">
              Vehicle Identification Number (VIN)
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="fill"
              value={vinValue}
              placeholder="Vin"
              readOnly
              style={{
                backgroundColor: "#F8F8F8",
                border: "0.8px solid #E5E5E5",
                pointerEvents: "none", // optional: prevents editing
              }}
            />
          </div>
          <div className="col-xl-6">
            <label htmlFor="type" className="form-label fw-400 mt-2">
              Last KM Record While Fueling
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="fill"
              placeholder="Last Km Record"
              value={lastKmRecord}
              readOnly
              style={{
                backgroundColor: "#F8F8F8",
                border: "0.8px solid #E5E5E5",
                pointerEvents: "none", // optional: prevents editing
              }}
            />
          </div>

          <div className="col-xl-6 mt-2">
            <label htmlFor="kmd" className="form-label  fw-400 d-flex">
              Current KM While Fueling<span className="error-text">*</span>
            </label>
            <input
              type="number"
              className="form-control rounded-3 vehicle-form-input"
              id="fill"
              onChange={handleCurrentKmChange}
              placeholder="Enter current km"
              value={currentKm}
            />{" "}
            <span className="error-text">{errorMsg.km}</span>
          </div>
          <div className="col-xl-6 mt-2">
            <label htmlFor="type" className="form-label fw-400">
              Fuel Type
            </label>
            <CommonStaticDropdown
              items={fuelTypeList}
              placeholder="Select type"
              value={selectedFuelType}
              onSelect={handleSelectFuelType}
              enableSearch={false}
            />
            <span className="error-text">{errorMsg.fuel_type}</span>
          </div>

          <div className="col-xl-6 mt-2">
            <label htmlFor="qty" className="form-label fw-400 d-flex">
              {fuelQtyLabel}
              <span className="error-text">*</span>
            </label>
            <input
              type="number"
              className="form-control rounded-3 vehicle-form-input"
              id="qty"
              onChange={handleFuelQtyChange}
              placeholder="Enter fuel qty"
              value={fuelQty}
            />
            <span className="error-text">{errorMsg.qty}</span>
          </div>

          <div className="col-xl-6 mt-2">
            <label htmlFor="price" className="form-label fw-400 d-flex">
              {fuelPriceLabel}
              <span className="error-text">*</span>
            </label>
            <input
              type="number"
              className="form-control rounded-3 vehicle-form-input"
              id="price"
              onChange={handleFuelPriceChange}
              placeholder="Enter fuel price"
              value={fuelPrice}
            />
            <span className="error-text">{errorMsg.price}</span>
          </div>

          <div className="col-xl-6 mt-2">
            <label htmlFor="kmd" className="form-label  fw-400 d-flex">
              Total Price
            </label>
            <input
              type="text"
              className="form-control rounded-3 vehicle-form-input"
              id="fill"
              placeholder="Total price"
              value={totalPrice}
              readOnly
              style={{
                backgroundColor: "#F8F8F8",
                border: "0.8px solid #E5E5E5",
                pointerEvents: "none", // optional: prevents editing
              }}
            />{" "}
          </div>

          <FileUploader
            label="Upload  image"
            onFileSelect={handleFileSelect}
            editImg={imageEdit ? [imageEdit] : []}
            onRemoveEdit={removeEditImage} // Pass removal function
          />
          <div className="d-flex gap-3 justify-content-end mt-5">
            <Button
              className="bg-white rounded-3 px-4 py-2 pagination-color btn-border-grey"
              onClick={handleCloseWithReset}
            >
              Cancel
            </Button>
            <Button
              className={`dark-purple-btn ${
                isLoader ? "disabled-btn" : ""
              } rounded-3 py-2 px-4`}
              onClick={submitForm}
              style={{ minWidth: "100px" }}
            >
              {" "}
              {isLoader ? (
                <Spinner animation="border" size="sm" />
              ) : id !== null ? (
                "Update"
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default FuelFistoryForm;
